// @flow

export class AuthError extends Error {}
export class NetworkError extends Error {}
